<!-- 百分比上传组件 -->
<template>
    <div class="load-btn">
        <el-upload ref="upload"
                   :disabled="upState == 'loading'"
                   class="upload-btn"
                   :action="upUrl"
                   :before-upload="prevCtrls"
                   :on-progress="pgressCtrls"
                   :on-error="errorCtrls"
                   :on-success="successCtrls"
                   :show-file-list="false"
                   :data="fileData" multiple
                   :limit="3"
                   :on-exceed="handleExceed"
        >
            <el-button :disabled="upState == 'loading'" size="small">
                <span v-if="upState == 'wait' || upState == 'loading'">上传</span>
                <span v-if="upState == 'loaded'">更新</span>
            </el-button>
            <div class="tips" style="margin-left:12px;">注：上传文件格式为JPEG/PNG，文件大小不超过10M</div>
        </el-upload>

        <div class="progressBox">
            <el-progress v-show="upState == 'loading'" :stroke-width="9" :percentage="percentage"></el-progress>
        </div>
        <div v-show="upState == 'loaded'" class="imgBox">
            <img @click="dialogVisible = true" :src="imgUrl" />
        </div>
        <div>
            <div class="edName uploadLine"></div>
            <div class="icons">
                <img src="~@/assets/images/left.png" @click="handleLeftRotate(imgUrl)">
                <img src="~@/assets/images/right.png" @click="handleRightRotate(imgUrl)">
                <el-button type="primary" size="small" @click="submitUpload">保存</el-button>
            </div>
        </div>

        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="imgUrl" alt="">
        </el-dialog>

    </div>
</template>

<script>
    import { rotateImg, dataURLtoFile } from  '../../components/ImgFilp/canvas-rotate-image';
    import {
      getToken
    } from '@/utils/auth';
    import {
      getFileToken
    } from '@/api/account';
    import{postImg} from '@/api/pressRole/pressRole';
    export default {
        props: ['ableSure'],
        name: "uploadCards",
        data() {
            return {
                dialogVisible:false,
                percentage: 0,
                upState: 'wait',
                fileData: {},
                imgUrl: '',
                fileToken: '',
                upUrl:'',
                disabled: false,
                // 图片属性
                img: {
                    name: '',
                    type: ''
                },
                showSaveBtn:false
            }
        },
        watch: {
            ableSure: function(dat) {
              this.imgInit(this.ableSure);
            }
        },
        methods: {
            // 左转
            handleLeftRotate(imageUrl) {
                const that = this;
                that.showSaveBtn = true;
                rotateImg(imageUrl, -90, function (base64) {
                    that.imgUrl = base64;
                });
            },
            // 右转
            handleRightRotate(imageUrl) {
                const that = this;
                that.showSaveBtn = true;
                rotateImg(imageUrl, 90, function (base64) {
                    that.imgUrl = base64;
                });
            },
            //手动提交图片
            submitUpload() {
                // this.$refs.upload.submit();
                let file = dataURLtoFile(this.imgUrl, this.img.name);
                let param = new FormData(); //创建form对象
                param.append('file',file);//通过append向form对象添加数据
                param.append('token',getToken());//通过append向form对象添加数据
                console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
                let config = {
                    headers:{'Content-Type':'multipart/form-data'}
                }; //添加请求头
                postImg({file:param, config}).then((res) => {
                    console.log(res)
                })
                // Request.post(this.upUrl,param,config)
                //     .then(res=>{
                //         console.log(res.data);
                //         // this.imgUrl = res.data.imgUrl;
                //     })
            },
            // 移除图片
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            // 图片预览
            handlePreview(file) {
                console.log(file);
            },
            // 图片上传前的判断
            prevCtrls: function(file) {
                let nameArr = file.type.split('/');
                let fileType = nameArr[nameArr.length - 1];

                if (fileType != 'jpeg' && fileType != 'png') {
                    this.$message({
                        message: '请上传格式为 JPGE 或 PNG 的文件！',
                        type: 'error'
                    })
                    return false;
                } else if (file.size / 1024 / 1024 > 10) {
                    this.$message({
                        message: '文件大小不能超过 10M！',
                        type: 'error'
                    })
                    return false;
                } else {
                    this.percentage = 0;
                    this.upState = 'loading';
                    this.fileData.token = getToken();
                    this.fileData.fileSize = file.size;

                    return true;

                }
            },
            pgressCtrls: function(evt, file) {
                this.percentage = parseInt(file.percentage);
                this.img.name = file.name;
                this.img.type = file.raw.type;
            },
            errorCtrls: function(err) {
                this.upState = "wait";
                this.$alert('上传失败，请稍后重试！', '提示', {
                    confirmButtonText: '确定',
                    type: 'error'
                })
            },
            successCtrls: function(data) {
              this.percentage = 100;
              this.ableSure = data.payload.id;
              this.imgInit(data.payload.id);
              this.$emit('upFileId', data.payload.id);
            },
            // successCtrls: function(res) {
            //     this.upState = 'loaded';
            //     // this.imgUrl = res.data.imgUrl;
            //     this.percentage = 100;
            //     this.ableSure = data.payload.id;
            //     this.imgInit(data.payload.id);
            //     this.$emit('upFileId', data.payload.id);
            // },

            imgInit: function(dat) {
                if (dat) {
                    this.upState = 'loaded';
                    this.imgUrl = process.env.BASE_API + '/File/File/view/token/' + this.fileToken + '/id/' + dat;
                }
            },

            handleExceed: function() {

            }
        },

        created: function() {
            this.upUrl = process.env.BASE_API + '/File/File/upload';
            getFileToken().then(response => {
              this.fileToken = response.resultStatus.token;
              this.imgInit(this.ableSure);
            })

        }
    }
</script>

<style scope>
    .upload-btn {
        display: inline-block;
    }

    .progressBox {
        width: 480px;
        margin-top: 6px;
    }

    .imgBox {
        height: 120px;
        margin-bottom: 9px;
    }

    .imgBox img {
        height: 100%;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// upload.vue?26716ad6